import { defineDirective, IOmniaShell, shell } from "../omnia"
import { IDatalayersService } from "../types"
import { YieldScalesContext } from "./context"

/// <reference path="context.ts" />

import m = omnia.models;

export class YieldScalePopupCtrl extends shell.Dialog {

    static create(): ng.IDirective {

        return defineDirective(YieldScalePopupCtrl, "app/datalayers/yield-scales/yield-scales-popup.html");

    };

    private context: YieldScalesContext;

    static $inject = ["$scope", "OmniaShell", "OmniaDatalayersService"];

    constructor($scope: ng.IScope, shell: IOmniaShell, private svc: IDatalayersService) {
        super($scope, shell);
    }

    $onInit() {
        this.setup();
    }

    protected setup() {

        this.context = new YieldScalesContext(this.svc);

    }

    canCancel() {
        return true;
    }

    cancel() {
        this.close(false);
    }

    createScale() {
        this.context.createScale()
    }

    isEditing() {
        return this.context && this.context.isEditing && this.context.isEditing()
    }

    endEdition() {
        this.context.endEdition()
    }

    canCommit(): boolean {
        return this.context.canCommit();
    }

    commit() {
        this.context.commit().then(r => this.close(true));
    }

}
